import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IFalgExamList } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const ListFlagExamSlice = createSlice({
  name: "ListFlagExamSlice",
  initialState: {} as IReduxState<IFalgExamList[]>,
  reducers: {
    listFlagExam: (state, _: PayloadAction<IFalgExamList>) => {
      state.isLoading = true;
    },
    successlistFlagExam: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistFlagExam: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistFlagExam, listFlagExam, successlistFlagExam } =
  ListFlagExamSlice.actions;

export default ListFlagExamSlice.reducer;
